import { UrlApi } from "../../../services/apirest";
import React, { useState, useEffect, useRef } from "react";
import {
  Typography,
  Snackbar,
  Box,
  Button,
  Stack,
  TextField,
  Tooltip,
  Grid,
  Checkbox,
  FormControlLabel,
  Paper,
} from "@mui/material";
import moment from "moment";
import { read, utils } from "xlsx";
import { enviarsms } from "../../../services/services";
import { getData } from "../../../services/library";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import MuiAlert from "@mui/material/Alert";
import NotAllow from "../notAllow/NotAllow";
import MessageIcon from "@mui/icons-material/Message";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Formcargamenu = ({ id_tipo }) => {
  const [menus, setMenus] = useState([]);
  const [openSnack, setOpenSnack] = React.useState(false); //abre y cierra snack
  const [colormensaje, setColorMensaje] = useState(""); //define el color que tendrá la notificación
  const [mensaje, setMensaje] = useState(""); //mensaje q mostrará la notif
  const [disBtn, setDisBtn] = useState(false);
  const [diasSemana, setDiasSemana] = useState([]);
  const [contadorBtn, setContadorBtn] = useState(0);
  const fileInputRef = useRef(null);
  const [menusDesdeExcelDia, setMenusDesdeExcelDia] = useState([]);
  const [menusDesdeExcelRotativo, setMenusDesdeExcelRotativo] = useState([]);
  const [users, setUsers] = useState([]);
  const smsYaEnviado = useRef(false); //usamos ref

  const fetchDiasSemana = async () => {
    try {
      const res = await fetch(`${UrlApi}/viandas/menu/days`);
      const data = await res.json();
      setDiasSemana(data);
    } catch (error) {
      console.error("Error al traer días de la semana:", error);
    }
  };

  useEffect(() => {
    getData("/viandas/menu/usuariosSMS", setUsers);
    fetchDiasSemana();
  }, []);

  const mandarSMS = (listaDeUsuarios) => {
    const usuarios = listaDeUsuarios.data;

    usuarios.forEach((user) => {
      setTimeout(() => {
        const { celular, nombrepila, apellido } = user;
        const message = `Hola ${nombrepila} ${apellido}, te informamos que ya se pueden seleccionar las viandas`;
        enviarsms(celular, message);
      }, 2000);
    });
  };

  const normalizarT = (t) => {
    return t
      ?.normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // elimina tildes
      .toLowerCase()
      .replace(/\s+/g, " ") // reemplaza cualquier secuencia de espacios, tabs o saltos por un solo espacio
      .trim(); // borra espacios extremos
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = read(data, { type: "array" });

      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      const jsonData = utils.sheet_to_json(worksheet, { header: 1 });

      if (jsonData.length < 4) return; // Validación mínima

      // Menú del día (fila 2 y 3)
      const diasSemana = jsonData[1]; // Ej: ["", "Lunes", "Martes", ...]
      const menusDia = jsonData[2]; // Ej: ["Menú Rotativo", "Albóndigas...", ...]

      const datosMenusDia = diasSemana
        .map((dia, index) => {
          if (index === 0 || !dia) return null;
          return {
            dia,
            menu: normalizarT(menusDia[index]) || "",
          };
        })
        .filter(Boolean);

      setMenusDesdeExcelDia(datosMenusDia);

      // Menú rotativo (fila 4 en adelante)
      const regex = /^\d{1,2}-/;
      const datosMenusRotativo = jsonData
        .slice(4) // Desde fila 5 en adelante  // .slice(4)0 1 ,2 ,3 ,4
        .map((row) => {
          const menuTexto = row[0]; // Primera columna de cada fila
          return menuTexto ? { menu: normalizarT(menuTexto) } : null;
        })
        .filter(Boolean)
        .filter((item) => regex.test(item.menu));

      setMenusDesdeExcelRotativo(datosMenusRotativo);
    };

    reader.readAsArrayBuffer(file);
  };

  const handleChange = (index, field, value) => {
    // console.log("index", index, "field", field, "value", value);
    const newMenus = [...menus];
    newMenus[index][field] = value;
    setMenus(newMenus);
  };

  useEffect(() => {
    if (!id_tipo) return;
    if (id_tipo === 305 && diasSemana && diasSemana.length === 0) return;

    const cantidad = id_tipo === 306 ? menusDesdeExcelRotativo.length : 5;
    const menusGenerados = [];

    for (let i = 0; i < cantidad; i++) {
      let fecha = null;

      if (id_tipo === 305 && diasSemana[i]) {
        const diaObj = diasSemana[i];
        const clave = Object.keys(diaObj)[0];
        fecha = moment(diaObj[clave], "DD/MM/YYYY").format("YYYY-MM-DD");
      }

      menusGenerados.push({
        fecha,
        id_tipo,
        menu: "",
        guarnicion: "",
        feriado: 0,
      });
    }

    setMenus(menusGenerados);
  }, [id_tipo, diasSemana, menusDesdeExcelRotativo]);

  const agregar = async (e) => {
    e.preventDefault();
    setDisBtn(true);

    const user = localStorage.getItem("user") || "sin_usuario";

    const payload = menus.map((item) => ({
      ...item,
      id_tipo,
      user,
      // Si el menu ya tiene un ID, lo incluimos para que sea update. (En el back lo difrenecia)
      ...(item.id_menu && { id_menu: item.id_menu }),
    }));

    try {
      const response = await fetch(`${UrlApi}/viandas/menu/crear`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const json = await response.json();

      if (!response.ok) {
        console.error("❌ Error de API:", json);
        return;
      }

      if (response.status === 207 && Array.isArray(json)) {
        const errores = json.filter((item) => !item.ok);
        const exitos = json.filter((item) => item.ok);

        const actualizaciones = exitos.filter((item) =>
          item.message?.includes("actualizó")
        );
        const inserciones = exitos.filter((item) =>
          item.message?.includes("insertó")
        );

        if (errores.length === 0) {
          setColorMensaje("#D4EFDF");
          if (actualizaciones.length > 0 && inserciones.length === 0) {
            setMensaje("Todos los menús fueron actualizados correctamente.");
          } else if (inserciones.length > 0 && actualizaciones.length === 0) {
            setMensaje("Todos los menús fueron guardados correctamente.");
          } else {
            setMensaje(
              `Se guardaron ${inserciones.length} menús y se actualizaron ${actualizaciones.length}.`
            );
          }

          // Solo mandamos SMS en inserciones, no en actualizaciones
          if (
            id_tipo !== 306 &&
            inserciones.length > 0 &&
            !smsYaEnviado.current
          ) {
            mandarSMS(users);
            smsYaEnviado.current = true;
          }
        } else if (exitos.length === 0) {
          setColorMensaje("#FADBD8");
          setMensaje("Ningún menú fue procesado. Verifique los datos.");
        } else {
          setColorMensaje("#FCF3CF");
          setMensaje(
            `Se procesaron ${exitos.length} menús, pero ${errores.length} tuvieron errores.`
          );
        }
        setOpenSnack(true);
        return;
      }

      if (json.message === "Se insertó correctamente") {
        setColorMensaje("#D4EFDF");
        setMensaje("Menú guardado correctamente.");
        setOpenSnack(true);
      }
    } catch (err) {
      console.error("Fallo en conexión con la API:", err);
    } finally {
      setDisBtn(false);
    }
  };

  useEffect(() => {
    if (!id_tipo || id_tipo <= 0) {
      console.log("Esperando un id_tipo válido...");
      return;
    }

    getData(`/viandasfech/traerMenu/${id_tipo}`, setMenus);
  }, [id_tipo]);

  //valida que no queden campos vacios que valide que no tome los espacios vacios
  const validateForm = () => {
    return menus.every((item) => item.menu !== "");
  };

  useEffect(() => {
    setDisBtn(!validateForm()); // Deshabilita el botón si algún campo está vacío
  }, [menus]);

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };

  useEffect(() => {
    if (!menusDesdeExcelDia.length && !menusDesdeExcelRotativo.length) return;

    const normalizarTexto = (texto) =>
      texto
        ?.normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // elimina tildes
        .toLowerCase()
        .replace(/\s+/g, " ") // reemplaza cualquier secuencia de espacios, tabs o saltos por un solo espacio
        .trim(); // borra espacios extremos

    setMenus((prevMenus) => {
      const tieneMenuDiario = prevMenus.some((item) => item.id_tipo === 305);
      const tieneMenuRotativo = prevMenus.some((item) => item.id_tipo === 306);

      if (tieneMenuDiario && !menusDesdeExcelDia.length) return prevMenus;
      if (tieneMenuRotativo && !menusDesdeExcelRotativo.length)
        return prevMenus;

      const menusActualizados = prevMenus.map((item, index) => {
        if (item.id_tipo === 305) {
          const diaNombre = moment(item.fecha).format("dddd"); // ejemplo: "miércoles"
          const encontrado = menusDesdeExcelDia.find(
            (m) => normalizarTexto(m.dia) === normalizarTexto(diaNombre)
          );
          return {
            ...item,
            menu: encontrado ? encontrado.menu : item.menu,
          };
        }

        if (item.id_tipo === 306) {
          const idx = index % menusDesdeExcelRotativo.length;
          return {
            ...item,
            menu: menusDesdeExcelRotativo[idx].menu,
          };
        }

        return item;
      });

      return menusActualizados;
    });
  }, [menusDesdeExcelDia, menusDesdeExcelRotativo]);

  useEffect(() => {
    if (!id_tipo || id_tipo <= 0) {
      console.log("Esperando un id_tipo válido...");
      return;
    }
    getData(`/viandasfech/traerMenu/${id_tipo}`, setMenus);
  }, [id_tipo]);

  if (!id_tipo) return null;

  const rrhhAdmin = localStorage.getItem("adminrrhh");

  return rrhhAdmin === "1" ? (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          mt: 5, // margen superior
          position: "relative",
        }}
      >
        <Tooltip title="Enviar SMS a los usuarios para informarles que ya pueden seleccionar sus viandas">
          <Button
            variant="contained"
            color="success"
            disabled={contadorBtn > 0} // Deshabilita si ya se envió el SMS
            startIcon={<MessageIcon />}
            sx={{ top: -25, marginLeft: "75%" }}
            onClick={() => {
              setColorMensaje("#acd1a9");
              setMensaje("Los usuarios han sido informados.");
              setOpenSnack(true);
              setContadorBtn(1); // Incrementa el contador para deshabilitar el botón
              mandarSMS(users);
            }}
          >
            <Typography variant="button" sx={{ whiteSpace: "pre-line" }}>
              Informar a los usuarios
            </Typography>
          </Button>
        </Tooltip>
        {id_tipo === 306 ? (
          <>
            <Grid container spacing={2}>
              <Box sx={{ maxWidth: 800, margin: "0 auto" }}>
                <Paper
                  elevation={4}
                  sx={{
                    borderRadius: 4,
                    p: 3,
                    mb: 3,
                    boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
                    backgroundColor: "#fafafa",
                  }}
                >
                  <Grid container spacing={2}>
                    {menus.map((item, index) => (
                      <Grid item xs={12} sm={6} key={index}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                            flexWrap: "wrap",
                          }}
                        >
                          <Typography sx={{ minWidth: 70, fontWeight: "bold" }}>
                            Menú {index + 1}
                          </Typography>

                          {id_tipo !== 306 && (
                            <Typography sx={{ width: 140 }}>
                              {moment(item.fecha).format("dddd DD-MM-YYYY")}
                            </Typography>
                          )}

                          {id_tipo !== 306 && (
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={item.feriado === 1}
                                  onChange={(e) =>
                                    handleChange(
                                      index,
                                      "feriado",
                                      e.target.checked ? 1 : 0
                                    )
                                  }
                                />
                              }
                              label="Feriado"
                              sx={{ mx: 0.5 }}
                            />
                          )}

                          <TextField
                            label="Menú"
                            value={item.menu}
                            onChange={(e) =>
                              handleChange(index, "menu", e.target.value)
                            }
                            size="small"
                            sx={{ width: 280 }}
                          />
                        </Box>
                      </Grid>
                    ))}
                    <Grid
                      item
                      xs={12}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 2,
                        mt: 2,
                      }}
                    >
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => fileInputRef.current.click()}
                        startIcon={<FileUploadIcon />}
                        sx={{ mb: 2 }}
                      >
                        {id_tipo === 305
                          ? "Cargar Menú Diario"
                          : "Cargar Menú Rotativo"}
                      </Button>
                      <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        accept=".xlsx, .ods"
                        onChange={handleFileUpload}
                      />
                      <br />
                      <Button
                        variant="contained"
                        onClick={agregar}
                        disabled={disBtn || !menus.every((item) => item.menu)}
                      >
                        Guardar Menús
                      </Button>
                    </Grid>
                  </Grid>
                </Paper>
              </Box>
            </Grid>
          </>
        ) : (
          <>
            <Paper
              elevation={4}
              sx={{
                borderRadius: 4,
                p: 3,
                mb: 3,
                boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
                backgroundColor: "#fafafa",
              }}
            >
              {menus.map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    gap: 2,
                    mb: 2,
                  }}
                >
                  <Typography sx={{ width: 200 }}>
                    {moment(item.fecha).format("dddd DD-MM-YYYY")}
                  </Typography>

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={item.feriado === 1}
                        onChange={(e) =>
                          handleChange(
                            index,
                            "feriado",
                            e.target.checked ? 1 : 0
                          )
                        }
                      />
                    }
                    label="Feriado/No Laborable"
                    sx={{ mx: 2 }}
                  />

                  <TextField
                    fullWidth
                    multiline
                    minRows={2}
                    variant="outlined"
                    label="Menú"
                    value={item.feriado === 1 ? "Es feriado" : item.menu}
                    onChange={(e) =>
                      handleChange(index, "menu", e.target.value)
                    }
                    sx={{ mx: 1, width: 500 }}
                    disabled={item.feriado === 1}
                  />
                </Box>
              ))}

              {/* Botones debajo */}
              <Box display="flex" justifyContent="center" gap={2} mt={3}>
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  accept=".xlsx, .ods"
                  onChange={handleFileUpload}
                />
                <Button
                  sx={{ mt: 2 }}
                  variant="contained"
                  color="secondary"
                  // fullWidth
                  onClick={() => fileInputRef.current.click()}
                  startIcon={<FileUploadIcon />}
                >
                  {id_tipo === 305
                    ? "Cargar Menú Diario"
                    : "Cargar Menú Rotativo"}
                </Button>
                <Button
                  variant="contained"
                  onClick={agregar}
                  disabled={disBtn || !menus.every((item) => item.menu)}
                  sx={{ mt: 2 }}
                >
                  Guardar menús
                </Button>
              </Box>
            </Paper>
          </>
        )}
      </Box>

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  ) : (
    <NotAllow />
  );
};

export default Formcargamenu;
